"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBoardNotification = parseBoardNotification;
exports.parseSlotNotification = parseSlotNotification;
function parseBoardNotification(notification) {
    return {
        id: notification.PostID,
        userId: notification.UserID,
        message: notification.Message,
        userName: notification.UserName,
        seenBy: notification.SeenBy,
        date: new Date(notification.Date * 1000),
        boardData: {
            createdStr: notification.CreatedStr,
            parentID: notification.ParentID,
        },
    };
}
function parseSlotNotification(notification) {
    return {
        id: notification.SlotLogId,
        userId: notification.ReferenceId,
        message: notification.Msg,
        userName: notification.Author,
        seenBy: notification.SeenBy,
        date: new Date(notification.Date * 1000),
        slotData: {
            slotUserId: notification.SlotUserId,
            slotColor: notification.SlotColor,
            slotFrom: notification.SlotFrom,
            slotText: notification.SlotText,
        },
    };
}
